var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-gray-900",attrs:{"id":"home"}},[_c('gc-header'),_c('gc-mobile-nav'),_c('gc-landing'),_c('gc-collection'),_c('gc-story'),_c('gc-roadmap'),_c('gc-faq'),_c('gc-team'),_c('gc-partners'),_c('gc-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }